import {Checkbox, Divider, Grid, Typography} from '@yandex-delivery/blocks'
import React, {useCallback} from 'react'

import * as classes from './FilterItem.classes'
import type {Props} from './types'

export function FilterItem(props: Props): React.ReactElement<Props> {
  const {label, onChange, value, name, checked, ...otherProps} = props
  const changeHandler = useCallback(
    (nextChecked: boolean, {target}: React.ChangeEvent<HTMLInputElement>) => {
      onChange(target.name, value === undefined ? nextChecked : value)
    },
    [onChange, value],
  )

  return (
    <>
      <Grid alignItems="center" className={classes.container} justify="space-between" container item>
        <Grid item>
          <Typography variant="body2">{label}</Typography>
        </Grid>
        <Grid item>
          <Checkbox checked={Boolean(checked)} name={name} size="s" {...otherProps} onChange={changeHandler} />
        </Grid>
      </Grid>
      <Divider />
    </>
  )
}
